// TIN-23: helper para protegerse de DOM-XSS al renderizar URLs cuyo origen
// es input de usuario (linkPropuesta, archivos pegados como link, etc.).
// React NO escapa `javascript:` ni `data:` en `<a href>`, por eso este filtro.

const PROTOCOLOS_PERMITIDOS = /^https?:\/\//i;

/**
 * Devuelve la URL si es segura (http o https), o `null` si no.
 * Uso típico:
 *   const safe = urlSegura(linkPropuesta);
 *   return safe ? <a href={safe}>...</a> : <span>...</span>;
 *
 * @param {unknown} url
 * @returns {string|null}
 */
export const urlSegura = (url) => {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();
  if (PROTOCOLOS_PERMITIDOS.test(u)) return u;
  return null;
};

export default urlSegura;
